const VALIDATE_PHONE_PATTERN = /^\+1[\s-]*\(?\d{3}\)?[\s-]*\d{3}[\s-]*\d{4}$/;
const VALIDATE_EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const initForms = () => {
  const modalSuccess = document.getElementById("success-modal")!;

  document.addEventListener("vg-mailer:success", ({ $form }: any) => {
    const modalForm = $form.closest("[data-modal-window]");

    if (modalForm) {
      modalForm.classList.remove("--active");
    }

    modalSuccess.classList.add("--active");
  });

  document.addEventListener("vg-mailer:validate:phone", ({ field }) => {
    if (!field.$input.value.match(VALIDATE_PHONE_PATTERN)) {
      field.setInputError(true, "Incorrect phone number");
    }
  });

  document.addEventListener("vg-mailer:validate:email", ({ field }) => {
    if (!field.$input.value.match(VALIDATE_EMAIL_PATTERN)) {
      field.setInputError(true, "Incorrect email");
    }
  });
};
